import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useSelector } from 'react-redux'
import DotIcon from '@material-ui/icons/FiberManualRecord'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center'
    },
    trapStatusWrapperLeft: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 4
    },
    trapStatusWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    dotIconActive: {
        marginLeft: 4,
        color: theme.active
    },
    dotIconInactive: {
        marginLeft: 4,
        color: theme.error
    }
}))

export default function TrapsStatus(props) {
    const classes = useStyles()
    const { theme } = useSelector(state => state.main)

    const { trap1, trap2 } = props

    return (
        <div className={classes.root}>
            <div className={classes.trapStatusWrapperLeft}>
                <div>
                    Trap 1
                </div>
                <DotIcon
                    className={trap1 ? classes.dotIconActive : classes.dotIconInactive}
                />
            </div>
            <div className={classes.trapStatusWrapper}>
                <div>
                    Trap 2
                </div>
                <DotIcon
                    className={trap2 ? classes.dotIconActive : classes.dotIconInactive}
                />
            </div>
        </div>
    )
}
